/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Content } from './content';
import { ContentRate } from './contentRate';
import { ServiceProviders } from './serviceProviders';

export interface AddContentServiceProvider { 
    serviceProvider?: ServiceProviders;
    content?: Content;
    contentRate?: Array<ContentRate>;
    userId?: string;
    applicationId?: string;
    applicationName?: string;
    email?: string;
}